import { MonthlyCutoffDataType } from "../../../types";
import { getPreviousMonthYear, formatDate } from "../../../utils/date";
import { formatNumberWithCommas } from "../../../utils/numbers";

type GenerateProps = {
  meterSerialNo: string;
  results: MonthlyCutoffDataType[];
  showLiters: boolean;
};

function formatVolume(value: number | null | undefined, showLiters: boolean): string {
  if (value === null || value === undefined) return "--";
  if (showLiters) return formatNumberWithCommas(Math.round(value));
  const truncated = Math.trunc(value / 10) / 100;
  return formatNumberWithCommas(truncated);
}

export default function generateMonthlyCutoffsCsv({ meterSerialNo, results, showLiters }: GenerateProps) {
  const unitLabel = showLiters ? "(l)" : "(units)";

  const headers = [
    "Period",
    "Cut-off Timestamp",
    `Previous Month Rd. ${unitLabel}`,
    `End Of Month Reading ${unitLabel}`,
    `Monthly Consumption ${unitLabel}`,
  ];

  const rows = results.map((row) => [
    getPreviousMonthYear(row.cutoffDateTime),
    formatDate(row.cutoffDateTime),
    row.previousReading !== null && row.previousReading !== undefined
      ? formatVolume(row.previousReading, showLiters)
      : "--",
    formatVolume(row.reading, showLiters),
    formatVolume(row.consumption, showLiters),
  ].map((cell) => `"${String(cell).replace(/"/g, '""')}"`));

  const csvContent = [headers.map((h) => `"${h}"`).join(","), ...rows.map((r) => r.join(","))].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `monthly-report-${meterSerialNo}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
